// La píldora del SEGMENTO. Mismo chasis que la de nivel; lo que la distingue es el punto de color.
import { pillClass, pillDotClass, type PillSize } from './pillChassis';
import { segmentDotToneClass, segmentToneClass, type SegmentColorSlot } from './segmentColors';

export interface SegmentPillProps {
    name: string;
    colorSlot: SegmentColorSlot;
    /** `xs` (9.5px) por omisión, la densidad del backoffice; `sm` (11px) es la del wizard. */
    size?: PillSize;
    /** Presente ⇒ la píldora es un filtro que se prende y se apaga. */
    selected?: boolean;
    onToggle?: () => void;
    disabled?: boolean;
    title?: string;
    className?: string;
}

/** Punto de color + nombre, en pastel. El punto va SIEMPRE: es lo que ata el chip a su segmento. */
export function SegmentPill({
    name,
    colorSlot,
    size = 'xs',
    selected,
    onToggle,
    disabled = false,
    title,
    className,
}: SegmentPillProps) {
    const off = selected === false;
    const chipClass = pillClass({
        size,
        tone: segmentToneClass(colorSlot),
        off,
        interactive: onToggle !== undefined,
        className,
    });
    const body = (
        <>
            <span aria-hidden className={pillDotClass(size, segmentDotToneClass(colorSlot), off)} />
            <span className="truncate">{name}</span>
        </>
    );

    if (onToggle === undefined) {
        return (
            <span className={chipClass} title={title}>
                {body}
            </span>
        );
    }

    // `aria-disabled` y no `disabled`: con el atributo nativo el lector de pantalla se salta el
    // control y no anuncia su `title`, así que el corte del click va a mano.
    return (
        <button
            type="button"
            aria-pressed={selected ?? false}
            aria-disabled={disabled || undefined}
            title={title}
            onClick={() => {
                if (disabled) return;
                onToggle();
            }}
            className={chipClass}
        >
            {body}
        </button>
    );
}
